import React, {Component} from "react";
import Question from '../Question/Question';
import Loading from '../Loading/Loading';
import Results from '../Results/Results'
import unisexImg from '../../question-images/unisex.png'
import femaleImg from '../../question-images/female.jpg'
import maleImg from '../../question-images/male.jpg'
import dayImg from '../../question-images/daytime.jpg'
import eveningImg from '../../question-images/evening.jpg'
import versatileImg from '../../question-images/versatile.jpg'
import confidentImg from '../../question-images/confident.jpg'
import inspiredImg from '../../question-images/inspired.jpg'
import sensualImg from '../../question-images/sensual.jpg'
import elegantImg from '../../question-images/elegant.jpg'
import beachImg from '../../question-images/beach.jpg'
import cityImg from '../../question-images/city.jpg'
import countrysideImg from '../../question-images/country.jpg'
import skiingImg from '../../question-images/skiing.jpg'
import coffeeImg from '../../question-images/coffee.jpg'
import teaImg from '../../question-images/tea.jpg'
import sparklingImg from '../../question-images/sparkling.jpg'
import juiceImg from '../../question-images/juice.jpg'
import cottonImg from '../../question-images/cotton.jpg'
import tweedImg from '../../question-images/tweed.jpg'
import leatherImg from '../../question-images/leather.jpg'
import denimImg from '../../question-images/denim.jpg'
import silkImg from '../../question-images/silk.jpg'
import velvetImg from '../../question-images/velvet.jpg'
import freshImg from '../../question-images/fresh.jpg'
import floralImg from '../../question-images/floral.jpg'
import orientalImg from '../../question-images/oriental.jpg'
import woodyImg from '../../question-images/woody.jpg'
import citrusImg from '../../question-images/citrus.jpg'
import fruityImg from '../../question-images/fruity.jpg'
import herbalImg from '../../question-images/herbal.jpg'
import classicImg from '../../question-images/classic.jpg'
import exoticImg from '../../question-images/exotic.jpg'
import spicyImg from '../../question-images/spiced.jpg'
import sereneImg from '../../question-images/serene.jpg'
import earthyImg from '../../question-images/earthy.jpg'
import cleanImg from '../../question-images/clean.jpg'
import Filter from "../Filter/Filter";

import './QuestionList.css'

export default class QuestionList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentQuestion: 0,
      copied: false,
      answering: false,
      price: "middle",
      type: "",
      reanswering: false,
      questions: [
        {
          questionText: "Who is the gift for?",
          options: [
            {
              text: "For her",
              img: femaleImg,
              weightingName: 'female',
            },
            {
              text: "For him",
              img: maleImg,
              weightingName: 'male',
            }, 
            {
              text: "Variations thereupon",
              img: unisexImg,
              weightingName: 'unisex',
            },
          ]
        },
        {
          questionText: "What's their style?",
          options: [
            {
              text: "Traditional",
              img: tweedImg,
              weightingName: 'traditional',
            },
            {
              text: "Terribly Modern",
              img: denimImg,
              weightingName: 'contemporary',
            },
            {
              text: "Adventurous",
              img: leatherImg,
              weightingName: 'adventurous',
            }, 
          ]
        },
        {
          questionText: "What scent would they prefer?",
          options: [
            {
              text: "Citrus",
              img: citrusImg,
              weightingName: 'citrus',
            },
            {
              text: "Fresh",
              img: freshImg,
              weightingName: 'fresh',
            },
            {
              text: "Floral",
              img: floralImg,
              weightingName: 'floral',
            },
            {
              text: "Woody",
              img: woodyImg,
              weightingName: 'woody',
            }, 
          ]
        }
      ]
    }
    this.registerAnswer = this.registerAnswer.bind(this);
    this.handleTypeChange = this.handleTypeChange.bind(this);
    this.showResults = this.showResults.bind(this);
  }

  componentDidMount() {
    this.props.setTotalQuestions(this.state.questions);
  }

  componentWillReceiveProps(nextProps) {
    const {questions, currentQuestion} = this.state;
    if(currentQuestion === questions.length) {
      const {aggregatedQuestions} = this.props;
      // return this.props.getWeighting(aggregatedQuestions);
    }
    const {popQuestion} = nextProps;
    if(popQuestion !== null && popQuestion !== currentQuestion) {
      this.setState({ currentQuestion: popQuestion });
    }
  }

  registerAnswer(answer) {
    const q = this.state.questions[this.state.currentQuestion]; 
    if(window.history) {
      this.props.pushAnswer(answer, this.state.currentQuestion);
      let currentState = { q: this.state.currentQuestion, a: answer };
      window.history.replaceState(currentState, `Question ${this.state.currentQuestion + 1}`, `/${this.state.currentQuestion + 1}/${answer}`);
      let stateObj = { q: this.state.currentQuestion + 1 }
      if(this.state.currentQuestion + 1 === this.state.questions.length) {
        window.history.pushState(stateObj, `Results`, `/results`);
        this.props.trackPage(`/results`);
      } else {
        window.history.pushState(stateObj, `Question ${this.state.currentQuestion + 2}`, `/${this.state.currentQuestion + 2}`);
        this.props.trackPage(`/${this.state.currentQuestion + 2}`);
      }
    }
    let answering = true;
    if(this.props.aggregatedQuestions[this.state.currentQuestion + 1]) {
      answering = false;
      this.props.resetStatus();
    }
    this.props.setCurrentQuestion(this.state.currentQuestion + 1);
    if(this.state.currentQuestion === this.state.questions.length) {
      this.setState({ currentQuestion: this.state.currentQuestion + 1, answering });      
    } else {
      setTimeout( () => {
        this.setState({ currentQuestion: this.state.currentQuestion + 1, answering });
      }, 600);
    }
  }

  handleTypeChange(e, type) {
    this.setState({ type, answering: false });
    this.props.resetStatus();
  }

  showResults() {
    const {aggregatedQuestions} = this.props;
    const {type, price} = this.state;
    return this.props.getWeighting(aggregatedQuestions, type, price);
  }

  render() {
    const {questions, currentQuestion, answering, price, type} = this.state;
    const {status, winner, results, aggregatedQuestions} = this.props;
    const allAnswered = aggregatedQuestions[0] && aggregatedQuestions[1] && aggregatedQuestions[2];
    if(questions[currentQuestion] && questions[currentQuestion].branching) {
      questions[currentQuestion].options = questions[currentQuestion].options.filter( (option) => aggregatedQuestions.includes(option.showIf));
      questions[currentQuestion].options = questions[currentQuestion].options.filter( (option) => !aggregatedQuestions.includes(option.hideFor));
    }
    return (
      <div className="questionsList">
        { answering ?
          <button className="closeButton" onClick={ () => this.setState({ answering: false })}>
            &times;
          </button>
        : null }
        { status === "LOADING" ?
          <div className="results">
            <Loading />
          </div>
        : currentQuestion === questions.length && answering ?
          <Filter
            handleTypeChange={this.handleTypeChange}
            type={this.state.type}
            price={this.state.price}
            setPrice={(price) => this.setState({price})}
          />
        : currentQuestion < questions.length && answering ?
          <Question
            {...questions[currentQuestion]}
            onAnswerClick={this.registerAnswer}
            aggregatedQuestions={this.props.aggregatedQuestions}
            trackEvent={this.props.trackEvent}
            questionNumber={currentQuestion + 1}
          />
        :
          <div className="introSection">
            { currentQuestion === 0 ?
              <div>
                <header
                  className="marketingHeader"
                  style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/banner.jpg)` }}
                >
                  <h1>Gift Finder</h1>
                </header>
                <p class="intro">
                  No one forgets a gift from Penhaligon's. Find just the thing in four simple steps.
                </p>
                <div className="getStarted">
                  <button className="button button--dark full" onClick={ () => this.setState({ answering: true })}>Get Started</button>
                </div>
              </div>
            : null }
            { currentQuestion > 0 ?
              <nav className="questionTabs">
                { questions.map( (q, i) => {
                  const answered = aggregatedQuestions[i]
                  let answer
                  if(answered) {
                    answer = q.options.find( item => item.weightingName === answered )
                  }
                  return(
                    <div className="questionTab" onClick={ () => this.setState({ answering: true, currentQuestion: i })}>
                      <h2>{q.questionText}</h2>
                      { answered && answer ? 
                        <p>{answer.text}</p>
                      :
                        <p>Select Answer</p>                      
                      }
                    </div>
                  )
                })}
                <div className="questionTab" onClick={ () => this.setState({ answering: true, currentQuestion: 3 })}>
                  <h2>Type of Gift</h2>
                  { price && type ?
                    <p>{price === "cheap" ? "£" : price === "middle" ? "££" : "£££" } / {type}</p>                  
                  :
                    <p>Select Answer</p>                  
                  }
                </div>
              </nav>
            : null }
            { price && type && allAnswered && status !== "SUCCESS" ?
              <div className="giftSubmit">
                <button className="button button--dark full" onClick={this.showResults}>
                  Show Results
                </button>
              </div>
            : null }
            { status === "SUCCESS" && !answering ?
              <div className="resultsWrapper">
                <h2>Here are our suggestions</h2>
                <p>(Do feel free to change your answers&hellip;)</p>
                <div className="results">
                  { results.slice(0,6).map( result => {
                    return (
                      <div className="result">
                        <div className="resultImg">
                          <img src={result.fields.prodImgUrl} />
                        </div>
                        <div className="resultInfo">
                          <h2>{result.fields.name}</h2>
                          <h3>{result.fields.price}</h3>
                          <p>{result.fields.description}</p>
                        </div>
                        <div className="resultButton">
                          { this.props.basket.filter(item => item.fields.name === result.fields.name).length ?
                            <div className="qtySelector">
                              <button
                                className="qtyButton"
                                onClick={ () => this.props.changeQty(result, -1)}
                                disabled={result.qty <= 1 ? "disabled" : null }
                              >-</button>
                              <span>{ result.qty }</span>
                              <button className="qtyButton" onClick={ () => this.props.changeQty(result, +1) }>+</button>
                            </div>
                          :
                            <button className="button button--dark full" onClick={ () => this.props.addToBasket(result) }>
                              Add to bag
                            </button>
                          }
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            : null }
          </div>
        }
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/components/QuestionList/QuestionList.js